module.exports = __webpack_public_path__ + "img/success.fd6f3070.png";